<div
    [ngClass]="{ 'bg-secondaryMain hover:text-white': isSelected }"
    class="flex items-center h-10 w-fit text-base text-white py-0 px-1 hover:text-secondaryMain"
>
    <ng-content></ng-content>
    <span class="ml-4 w-[144px]" *ngIf="!hideName">{{name}}</span>
</div>
